import { message } from 'antd';
import { approveSubmission, getVMSApprove } from '../../../../services/popupApi';

export const api = {
  submit: async (values, context) => {
    const submissionId = context.selectedIds[0];
    await approveSubmission(submissionId, {
      candidateProposedRate: values.candidateProposedRate,
      candidateProposedRateCurrency: values.candidateProposedRateCurrency,
      candidateProposedRateUnit: values.candidateProposedRateUnit,
      submitVia: values.submitVia,
    });
    if (values.submitVia === 'VMS') {
      await getVMSApprove(submissionId);
    } else {
      message.info('Approved — use Send Mail to notify the client.');
    }
  },
};
